<!--
  Landing page footer as a reusable component.
  Markup + styles are the same as the footer that lives inside
  landing_page_middle_content.vue, so public pages look identical to the landing page.
-->
<template>
  <div class="landing-footer">
    <div class="footerContentHere">
      <div class="firstFotterDiv">
        <h2>Services</h2>
        <br />
        <div class="footer-services-icon-link-container">
          <router-link to="/hospitalList">
            <img class="footer-services-icon" src="@/assets/login/landingpageTopBar/hospital.png" alt="" />
            <span>Hospital | Clinic</span>
          </router-link>
        </div>
        <div class="footer-services-icon-link-container">
          <router-link to="/homeEcommerce">
            <img class="footer-services-icon" src="@/assets/login/landingpageTopBar/pharmacy.png" alt="" />
            <span>Pharmacy</span>
          </router-link>
        </div>
        <div class="footer-services-icon-link-container">
          <div class="footer-click" @click="navigatetoBigFileShare()">
            <img class="footer-services-icon" src="@/assets/login/landingpageTopBar/bigFileTransfer.png" alt="" />
            <span>Big File Sharing</span>
          </div>
        </div>
        <div class="footer-services-icon-link-container">
          <router-link to="/blogs">
            <img class="footer-services-icon" src="@/assets/login/landingpageTopBar/Blog.png" alt="" />
            <span>Blogs</span>
          </router-link>
        </div>
        <div class="footer-services-icon-link-container">
          <div class="footer-click" @click="navigatetoShowJobsPage()">
            <img class="footer-services-icon" src="@/assets/login/landingpageTopBar/job_board.svg" alt="" />
            <span>Healthcare Jobs</span>
          </div>
        </div>
      </div>

      <div class="firstFotterDiv">
        <h2>Company</h2>
        <div class="footer-company-sec">
          <router-link to="/contactUs"><p>Contact Us</p></router-link>
          <a class="footer-click" @click="navigatetoShowJobsPage()"><p>Career</p></a>
          <router-link to="/Terms"><p>Terms &amp; Condition</p></router-link>
          <router-link to="/PrivacyPolicy"><p>Privacy Policy</p></router-link>
          <router-link to="/refundpolicy"><p>Refund &amp; Cancellation Policy</p></router-link>
        </div>
      </div>

      <div class="firstFotterDiv">
        <h1 class="footerNewsletter">Subscribe now &amp; Get the latest updates</h1>
        <div class="footer_input_btn_container">
          <form @submit.prevent="handleSubscribe">
            <input class="newsletterinput" v-model="email" type="email" required placeholder="Email Address" />
            <div class="downloadAndSubscribeBtn">
              <button class="SubscribeButon" :disabled="isSubmitting">
                {{ isSubmitting ? "Subscribing..." : "Subscribe" }}
              </button>
              <a class="download-link" href="/apk_version/myhealthcouncil.apk" download>
                <button class="landing-page-DownloadBtn-A01" type="button">Download APP</button>
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>

    <button ref="scrollBtn" @click="scrollTop" class="scroll-to-top-btn" aria-label="Scroll to top">
      <img src="/Tree_landing_page.svg" alt="Scroll to top" title="Scroll To Top" style="height: 50px; width: 50px" />
    </button>

    <div class="copyrightFooter">
      <p>&copy; Copyright 2026 My Doctors Portal. All Rights Reserved.</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  name: "LandingFooter",

  data() {
    return {
      email: "",
      isSubmitting: false,
    };
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },

  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    // Big File Sharing / Jobs need a logged in user (same rule as the landing page)
    checkLogin() {
      const user = this.$store.getters.hasuserdetails;
      if (!user || Object.keys(user).length === 0) {
        toast.warning("Please login first");
        return false;
      }
      return true;
    },
    navigatetoBigFileShare() {
      if (!this.checkLogin()) return;
      this.$router.push("/large-file-upload");
    },
    navigatetoShowJobsPage() {
      if (!this.checkLogin()) return;
      this.$router.push("/showJobsPage");
    },

    async handleSubscribe() {
      this.isSubmitting = true;
      try {
        await axios.post(`${process.env.VUE_APP_BASE_URL}subscribers/user`, {
          email: this.email,
        });
        toast.success("Thank you for subscribing!");
        this.email = "";
      } catch (error) {
        toast.error("Failed to subscribe. Please try again.");
      } finally {
        this.isSubmitting = false;
      }
    },

    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleScroll() {
      const btn = this.$refs.scrollBtn;
      if (!btn) return;
      btn.classList.toggle("visible", window.scrollY > 200);
    },
  },
};
</script>

<style scoped>
.landing-footer {
  background-image: linear-gradient(#b5e3f0, transparent);
  margin-top: 20px;
  box-sizing: border-box;
}
.landing-footer *,
.landing-footer *::before,
.landing-footer *::after {
  box-sizing: border-box;
}

.footerContentHere {
  background-color: transparent;
  padding: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr 3fr;
}
.firstFotterDiv {
  padding: 25px;
}
.firstFotterDiv h2,
.firstFotterDiv p {
  color: #002d62;
  margin: 0;
}

.footer-services-icon {
  width: 1.1rem;
  position: relative;
  top: 2.9px;
  margin-right: 5px;
}
.footer-services-icon-link-container {
  margin-bottom: 8px;
}
.footer-services-icon-link-container a,
.footer-click {
  text-decoration: none;
  color: #002d62;
  cursor: pointer;
  font-size: clamp(12px, 2vw, 16px);
}

.footer-company-sec {
  margin-top: 26px;
}
.footer-company-sec a {
  text-decoration: none;
  font-size: clamp(12px, 2vw, 16px);
}
.footer-company-sec a p {
  margin-bottom: 6px;
}

.footerNewsletter {
  text-align: center;
  padding-bottom: 10px;
  color: #002d62;
  font-size: 18px;
  margin: 0;
}
.newsletterinput {
  width: 70%;
  padding: 10px;
  display: block;
  margin: auto;
  border: none;
  border-radius: 50px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  outline: none;
}
.downloadAndSubscribeBtn {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}
.download-link {
  width: fit-content;
  text-decoration: none;
}
.SubscribeButon {
  padding: 11px 69px;
  border-radius: 33px;
  color: #fff;
  background-color: #002d62;
  border: none;
  display: block;
  margin-top: 16px;
  cursor: pointer;
}
.SubscribeButon:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.landing-page-DownloadBtn-A01 {
  padding: 11px 69px;
  border-radius: 33px;
  background-color: transparent;
  border: #002d62 1px solid;
  display: block;
  margin-top: 16px;
  cursor: pointer;
  color: #002d62;
}

.copyrightFooter {
  font-size: clamp(12px, 2vw, 16px);
  padding: 7px;
}
.copyrightFooter p {
  text-align: center;
  color: #002d62;
  margin: 0;
}

/* scroll to top */
.scroll-to-top-btn {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
  background: transparent;
  border: none;
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transform: scale(0.5);
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.scroll-to-top-btn.visible {
  opacity: 1;
  pointer-events: auto;
  transform: scale(1);
}

@media screen and (max-width: 600px) {
  .footerContentHere {
    padding: 20px;
    grid-template-columns: 1fr;
  }
  .firstFotterDiv {
    padding: 25px 0;
  }
  .footer_input_btn_container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
  }
  .SubscribeButon,
  .landing-page-DownloadBtn-A01 {
    margin-top: 0;
    padding: 11px 36px;
  }
}
@media (max-width: 468px) {
  .newsletterinput {
    width: 100%;
  }
  .downloadAndSubscribeBtn {
    margin: 15px 0 !important;
  }
}
</style>
